<template>
  <div class="sidebar" style="z-index:100;overflow-y:scroll;">
    <ul class="sidebar-links">
      <router-link tag="li" id="home-sidebar-item" class="sidebar-item" to="/home/dashboard">
        <a>
          <i class="icon icon-home-simple"></i>
          <span class="item">Início</span>
        </a>
      </router-link>

     <!-- <router-link tag="li" id="home-sidebar-item" class="sidebar-item" to="/home/live">
        <a>
          <i class="icon icon-attach-86-2-2"></i>
          <span class="item">Aula ao vivo</span>
        </a>
      </router-link> -->

      <!-- <if test="#broadcast != null">
				<li id="broadcast-sidebar-item" class="sidebar-item">
					<a href="" target="_blank">
						<i class="icon icon-attach-86-2-2"></i><span class="item"> Aula ao vivo</span>
					</a>
				</li>
      </if>-->

      <!-- <router-link
        v-if="course"
        tag="li"
        id="home-sidebar-item"
        class="sidebar-item"
        to="/home/coursepanel"
      >
        <a href="#">
          <i class="icon icon-dashboard-30"></i>
          <span class="item">Painel do curso</span>
        </a>
      </router-link>-->

      <router-link
        v-if="course"
        tag="li"
        id="home-sidebar-item"
        class="sidebar-item"
        to="/home/classes"
      >
        <a value="#">
          <i class="icon icon-play-folder"></i>
          <span class="item">Aulas</span>
        </a>
      </router-link>

      <router-link tag="li" id="home-sidebar-item" class="sidebar-item" to="/home/questions">
        <a value="#">
          <i class="icon icon-chat-46"></i>
          <span class="item">Plantão de dúvidas</span>
        </a>
      </router-link>

      <router-link tag="li" id="home-sidebar-item" class="sidebar-item" to="/home/quizlist">
        <a value="#">
          <i class="icon icon-todo"></i>
          <span class="item">Avaliações</span>
        </a>
      </router-link>

      <router-link tag="li" id="home-sidebar-item" class="sidebar-item" to="/home/annotations">
        <a value="#">
          <i class="icon icon-single-copy-04"></i>
          <span class="item">Anotações</span>
        </a>
      </router-link>

      <router-link tag="li" id="home-sidebar-item" class="sidebar-item" to="/home/topics">
        <a value="#">
          <i class="icon icon-multiple-11"></i>
          <span class="item">Fórum</span>
        </a>
      </router-link>

      <li v-if="userType == 0 || userType == 2" id="broadcast-sidebar-item" class="sidebar-item">
        <a href="#">
          <i class="icon icon-settings-2"></i>
          <span class="item">Administrativo</span>
          <i class="icon icon-stre-down"></i>
        </a>
      </li>

      <router-link tag="li" v-if="userType !=1" id="home-sidebar-item" class="sidebar-item" to="/home/courses">
        <a value="#">
          <i class="material-icons">menu_book</i>
          <span class="item">Cursos</span>
        </a>
      </router-link>

       <router-link tag="li" id="home-sidebar-item" class="sidebar-item" to="/home/alerts" v-if="userType != 1">
        <a value="#">
          <i class="icon icon-alert-circle-exc"></i>
          <span class="item">Avisos</span>
        </a>
      </router-link>

      <router-link tag="li" id="home-sidebar-item" class="sidebar-item" to="/home/reports" v-if="userType == 0">
        <a value="#">
          <i class="material-icons">insert_chart_outlined</i>
          <span class="item">Relatórios</span>
        </a>
      </router-link>

      <div v-if="userType == 0">
        <router-link tag="li" id="home-sidebar-item" class="sidebar-item" to="/home/users">
          <a value="#">
            <i class="material-icons">people_outline</i>
            <span class="item">Usuários</span>
          </a>
        </router-link>

        <router-link tag="li" id="home-sidebar-item" class="sidebar-item" to="/home/products">
          <a value="#">
            <i class="fa fa-usd"></i>
            <span class="item">Produtos</span>
          </a>
        </router-link>
      </div>

      <!-- <li id="forum-sidebar-item" class="sidebar-item">
        <a value="/aluno/turma/%{id}/forum">
          <i class="icon icon-multiple-11"></i>
          <span class="item">Fórum</span>
        </a>
      </li>

      <li id="messages-sidebar-item" class="sidebar-item">
        <a value="/aluno/turma/%{id}/plantao-de-duvidas">
          <i class="icon icon-chat-46"></i>
          <span class="item-bg">Plantão de dúvidas</span>
        </a>
      </li>

      <li id="annotations-sidebar-item" class="sidebar-item">
        <a value="/aluno/turma/%{id}/anotacoes">
          <i class="icon icon-single-copy-04"></i>
          <span class="item">Anotações</span>
        </a>
      </li>

      <li id="activities-sidebar-item" class="sidebar-item">
        <a value="/aluno/turma/%{id}/atividade-complementar">
          <i class="icon icon-todo"></i>
          <span class="item-bg">Atividades complementares</span>
        </a>
      </li>-->
    </ul>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      userType: this.$store.getters.user.type,
      book: [],
      message: "",
      showMessage: false
    };
  },
  computed: {
    course: function() {
      return this.$store.getters.course;
    }
  },
  methods: {}
};
</script>
